export enum ResourceType {
  ASSET = 'asset',
  PLAYLIST = 'playlist',
  PLAYER = 'player',
  CAMPAIGN = 'campaign',
  PERMISSION = 'permission',
  USER = 'user'
}

export interface IURN {
  type: ResourceType
  tenantId: string
  id: string
  variant?: string
}
